'use strict'

// define 'newsletter' namespace
if (!('newsletter' in window)) window['newsletter'] = {};

/***********************
 * Global onload event *
 ***********************/

$(function() {
    let body = $('body');

    // On input of footer form, enable button
    $(body).on('input', '.newsletter-footer-form input[name=email]', function (e) {
        e.preventDefault();

        let newsletterRegisterBtn = $('[data-js=newsletter-register]');
        newsletterRegisterBtn.removeClass('btn-disabled');
        newsletterRegisterBtn.prop('disabled', false);
    });

    // On click of register, validate email form and save email to sessionStorage
    body.on('click', '[data-js=newsletter-register]', function (e) {
        newsletter.validateFooterForm();
        sessionStorage.content = $('input[name=email]').val();
    });

    // If the newsletterForm is visible, set the previously saved email and select detected language and country
    if ($('form[name=newsletter_form]').is(':visible')) {
        let emailInput = $('input[name=email]');
        emailInput.val(sessionStorage.content);

        if (emailInput.val()) {
            let newsletterConfirmBtn = $('#newsletterConfirm');

            newsletter.selectDetected('country');
            newsletter.selectDetected('language');

            newsletterConfirmBtn.removeClass('btn-disabled');
            newsletterConfirmBtn.prop('disabled', false);
        }

        // remove error on change of field
        $('input').on('change', function () {
            let name = $(this).attr('name');
            if(name === 'email' && !newsletter.validateEmail($(this).val())) {
                return;
            }

            $(this).next('.invalid-feedback').addClass('d-none');
        })
    }

    // On click of submit button, submit the form through the NewsletterFormController
    $('.newsletter-form-submit-button').on('click', function (e) {
        e.preventDefault();
        let form = $('#newsletter_form');
        newsletter.clearValidationErrors(form);
        newsletter.disableSubmit(form);
        let formData = new FormData(form[0]);

        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    newsletter.showConfirmation();
                }

                // No error was thrown but the response was not successful either, show the generic error message.
                if (!response.success) {
                    $('form .generic-error').addClass('d-block');
                }
            },
            error: function (response) {
                let errors = response.responseJSON.errors;

                if ('username' in errors) {
                    newsletter.showConfirmation();

                    return;
                }

                $.each(errors, function (field, error) {
                    let $errorSpan = $('.' + field +'.invalid-feedback');
                    $errorSpan
                        .css('display', 'block')
                        .removeClass('d-none')
                        .html(error);
                });

                newsletter.enableSubmit(form);
            }
        });
    });
});

/*********************************
 * Methods (in "newsletter" namespace) *
 *********************************/

/**
 * Calls email validation on the form, could be used for more thorough JS validation.
 *
 * @returns {boolean}
 */
newsletter.validateFooterForm = function () {
    const email = $('input[name=email]').val();
    let emailInvalid = $('.email.invalid-feedback');

    if (newsletter.validateEmail(email)) {
        emailInvalid.removeClass('d-inline-block');
    } else {
        e.preventDefault();
        emailInvalid.addClass('d-inline-block');
    }

    return false;
}

/**
 * Validates that the string passed into the function is an actual email address.
 *
 * @param email
 * @returns {*}
 */
newsletter.validateEmail = function (email) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
}

/**
 * If possible, sets the country or language input to the country or language we've detected.
 *
 * @param type
 */
newsletter.selectDetected = function (type) {
    let detectedValue, selector = null;

    if (type === 'language') {
        detectedValue = detected_language;
        selector = 'select[name=language_select] option';
    } else if (type === 'country') {
        detectedValue = detected_country_id;
        selector = 'select[name=country] option';
    }

    $.each($(selector), function (index, option) {
        let optionEl = $(option);
        if (optionEl.val().includes(detectedValue)) {
            optionEl.prop('selected', true);
        }
    });
}

/**
 * Shows the newsletter confirmation upon form submission
 */
newsletter.showConfirmation = function () {
    $('#confirmation-row').removeClass('d-none');
    $('#form-row').remove(); // delete entire dom structure :)
}

/**
 * Enables the newsletter submit button
 *
 * @param form
 */
newsletter.enableSubmit = function (form) {
    let submitBtn = form.find('.newsletter-form-submit-button');
    submitBtn.removeClass('btn-disabled');
    submitBtn.prop('disabled', false);
}

/**
 * Disables the newsletter submit button
 *
 * @param form
 */
newsletter.disableSubmit = function (form) {
    let submitBtn = form.find('.newsletter-form-submit-button');
    submitBtn.addClass('btn-disabled');
    submitBtn.prop('disabled', true);
}

/**
 * Clears all previously set validation errors.
 *
 * @param form
 */
newsletter.clearValidationErrors = function (form) {
    let formFields = form.serializeArray();

    // Remove field-specific errors
    $.each(formFields, function (fieldName, field) {
        let errorSpan = $(`.${fieldName}.invalid-feedback`);
        errorSpan.css('display', 'none');
        errorSpan.html('');
    });

}
